<template>
  <myDialog
    :isDialog="isDialog"
    title="查看"
    :width="'800px'"
    @handleClose="handleClose"
  >
    <template #content>
      <div class="view-detail">
        <table class="detail-table">
          <tbody>
            <tr>
              <td class="label">伤者姓名</td>
              <td class="value">{{ detail.injuredName || '-' }}</td>
              <td class="label">用人单位</td>
              <td class="value">{{ detail.employer || '-' }}</td>
            </tr>
            <tr>
              <td class="label">伤害类型</td>
              <td class="value">{{ detail.injuryTypeName || '-' }}</td>
              <td class="label">认定结论</td>
              <td class="value">{{ detail.conclusion || '-' }}</td>
            </tr>
            <tr>
              <td class="label">事故日期</td>
              <td class="value">{{ detail.accidentDate || '-' }}</td>
              <td class="label">申请日期</td>
              <td class="value">{{ detail.applicationDate || '-' }}</td>
            </tr>
            <tr>
              <td class="label">受理日期</td>
              <td class="value">{{ detail.acceptanceDate || '-' }}</td>
              <td class="label">认定日期</td>
              <td class="value">{{ detail.recognitionDate || '-' }}</td>
            </tr>
            <tr>
              <td class="label">承办人</td>
              <td class="value">{{ detail.handler || detail.auditor || '-' }}</td>
              <td class="label"></td>
              <td class="value"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <el-button @click="handleClose">关闭</el-button>
    </template>
  </myDialog>
</template>

<script>
export default {
  name: 'AuditDetail',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.view-detail {
  padding: 0;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

  tbody tr {
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    padding: 12px 16px;
    border-right: 1px solid #ebeef5;
    font-size: 14px;
    color: #303133;

    &:nth-child(4n) {
      border-right: none;
    }

    &.label {
      width: 100px;
      background: #fafafa;
      color: #606266;
      font-weight: 400;
    }

    &.value {
      min-width: 120px;
      background: #fff;
    }
  }
}

::v-deep .el-dialog__header {
  background: #297dee !important;
  padding: 17px 20px;
}

::v-deep .el-dialog__title {
  color: #fff !important;
  font-weight: 700;
  font-size: 17px;
}

::v-deep .el-dialog__headerbtn {
  top: 17px;
  width: 24px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;

  .el-dialog__close {
    color: #fff;
  }
}

::v-deep .el-dialog__footer {
  padding: 10px 20px;
  background: #f3f6f7;
  display: flex;
  justify-content: center;
}

::v-deep .el-button {
  padding: 8px 24px;
  border-radius: 4px;
}
</style>
